import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { OidcProvider } from 'redux-oidc'
import Routes from '../routes'
import store from '../_helpers/store'
import userManager from '../utils/userManager'
import 'semantic-ui-css/semantic.min.css'

import './App.css'
import 'react-toastify/dist/ReactToastify.css'
import '../assets/css/identityServer.css'
import { USE_IDENTITY_SERVER as USE_IDS } from '../_config'
import UserHelper from '../_helpers/UserHelper'

// Attempt to process redirect response early to avoid repeated authorization loops if CallbackComponent is bypassed.
if (!USE_IDS) {
    const hashOrQuery = window.location.search || window.location.hash;
    if (window.location.pathname === '/callback' && (hashOrQuery.includes('code=') || hashOrQuery.includes('id_token'))) {
        // Let redux-oidc CallbackComponent handle it; no action here other than logging.
        console.log('[App] Arrived at /callback with auth params');
    }
}

class App extends Component {
    render() {
        return (
            <Provider store={store}>
                <OidcProvider store={store} userManager={ UserHelper.getUserManager()}>
                    <Routes />
                </OidcProvider>
            </Provider>
        );
    }
}

export default App;
